import template from './form.checkbox-input.html';

// <tc-checkbox-input>
export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.form.checkbox-input',
    []
  )
  .component('tcCheckboxInput', {
    template,
    require: {
      form: '?^^form',
    },
    bindings: {
      me: '<',
      data: '<',
      fields: '<',
      element: '<',
      disabled: '<',
    },
    controller: function () {
      this.$onInit = function() {
        if (this.fields && this.element && this.element.name) {
          this.field = this.fields[this.element.name];
        } else {
          console.warn('CheckboxInput: fields or element not available');
        }
      };

      this.isFieldDisabled = () => {
        return (
          this.disabled ||
          !this.me ||
          !(this.field.editBy === this.me.type || !this.field.editBy)
        );
      };
    },
  }).name;
